import { Component, Inject, Injector, Optional, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { TranslateService } from '@ngx-translate/core';
import { BreadCrumbService } from 'src/app/share/service/bread-crumb.service';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { GALoggerService } from 'src/app/share/service/galogger.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { CmsService } from 'src/app/web-generator/cms-generator/service/cms.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { AbstractCmsSingle } from '../../abstract-cms-single';

@Component({
  selector: 'app-single-01',
  templateUrl: './index.component.html',
  styleUrls: [
    './index.component.scss',
    './../../../../module/cms-normal/cms-normal-01/index/index.component.scss',
  ]
})
export class IndexComponent extends AbstractCmsSingle {
  /** 到首頁的路徑 */
  toHomePath: string;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected translate: TranslateService,
    protected http: CommonHttpClientService,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected injector: Injector,
    protected templateService: TemplateService,
    protected serverConfigService: ServerConfigService,
    @Optional() @Inject(REQUEST) protected request: Request,
    protected cmsService: CmsService,
    protected breadCrumbService: BreadCrumbService,
    protected renderer: Renderer2,
    protected gALoggerService: GALoggerService,
  ) {
    super(route, router, translate, http, generatorEnv, platformId, injector, templateService, serverConfigService, request, cmsService, breadCrumbService, renderer, gALoggerService);
    this.toHomePath = `/${serverConfigService.config.lang}`;
  }

  friendlyPrint(evt: UIEvent) {
    evt.preventDefault();
    window.print();
  }
}
